import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomDialog from "../../global/components/CustomModal/CustomModal";
import { locationType } from "../../Models/Interface";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import history from "../../utils/history";
import urls from "../../global/constants/UrlConstants";
import DashboardIcon from "../../assets/images/dashboardIcon.png";
import {
  getDashboardParentStageCount,
  getDashboardPreSalesStageCount,
  getDashboardSalesStageCount,
  getDashboardSalesTeamStageCount,
  getDashboardSourceCount,
  getDashboardTeamStageCount,
  getDataProject,
} from "./DashboardService";
import { isTruthy, openErrorNotification } from "../../helpers/methods";
import notifiers from "../../global/constants/NotificationConstants";
import { store } from "../../utils/store";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectActiveOrganizationId,
  selectMemberships,
} from "../../redux/authSlice";
import { getTeamList } from "../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import CustomTile from "../../global/components/CustomTile/CustomTile";
import userNew from "../../assets/icons/Usernew.svg";
import userNew1 from "../../assets/icons/Usernew1.svg";
import userNew2 from "../../assets/icons/Usernew2.svg";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
} from "recharts";
import FunnelChart from "./Opportunity";
import { getStage } from "../MetaData/components/MetaList/components/LeadStageData/LeadStageListService";
import DashboardIvrPanel from "./DashboardIvrPanel";

interface customProps {
  handleClose: Function | undefined;
  location: locationType;
}

const CHART_COLORS = ["#841C39", "#000000"];

const ChevronSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const PanelHeader = ({ title }: { title: string }) => (
  <div className="border-b border-[#EEF0F5] px-5 py-3.5">
    <h3 className="text-[15px] font-bold text-[#111827]">{title}</h3>
  </div>
);

const UnderlineTabs = ({
  tabs,
  value,
  onChange,
}: {
  tabs: string[];
  value: number;
  onChange: (index: number) => void;
}) => (
  <div className="flex gap-1 border-b border-[#EEF0F5] px-4">
    {tabs.map((label, index) => (
      <button
        key={label}
        type="button"
        onClick={() => onChange(index)}
        className={`px-3 py-2.5 text-sm font-medium transition-colors ${
          value === index
            ? "border-b-2 border-[#841C39] text-[#841C39]"
            : "border-b-2 border-transparent text-[#6B7280] hover:text-[#841C39]"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);

const FilterChip = ({
  children,
  onClick,
  active,
  className = "",
}: {
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex h-10 items-center gap-2 rounded-xl border px-3.5 text-sm font-medium transition-colors ${
      active
        ? "border-[#841C39] bg-[#F9F0F4] text-[#841C39]"
        : "border-[#E5E7EB] bg-white text-[#374151] hover:border-[#D4B8C0] hover:bg-[#F8FAFC]"
    } ${className}`}
  >
    {children}
  </button>
);

const SkeletonBlock = ({ height }: { height: number }) => (
  <div
    className="w-full animate-pulse rounded-xl bg-[#F3F4F6]"
    style={{ height }}
  />
);

const Card = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={`overflow-hidden rounded-2xl border border-[#EEF0F5] bg-white shadow-[0_4px_20px_rgba(15,23,42,0.04)] ${className}`}
  >
    {children}
  </div>
);

const Dashboard = (props: customProps) => {
  const [dashboardSourceCount, setDashboardSourceCount] = useState<any>([]);
  const [funnelPreSalesStages, setFunnelPreSalesStages] = useState<any>([]);
  const [funnelSalesSatges, setFunneelSalesSatges] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [dashboardDataProject, setDashboardDataProject] = useState<any>([]);
  const [dashboardDataAllLead, setDashboardDataAllLead] = useState<any>({});
  const [dashboardDataStageAll, setDashbordAllStage] = useState<any>([]);
  const [teamList, setTeamList] = useState<any>([]);
  const [value, setValue] = React.useState(0);
  const [opportunityViewMode] = useState("chart");
  const [leadSourceViewMode] = useState("chart");
  const [leadProjectViewMode] = useState("chart");
  const [teamStageCount, setTeamStageCount] = useState<any>([]);
  const [salesTeamStageCount, setSalesTeamStageCount] = useState<any>([]);
  const [preSaleStageData, setPreSaleStageData] = useState<any>([]);
  const [saleStageData, setSaleStageData] = useState<any>([]);
  const [selectedTeam, setSelectedTeam] = React.useState(0);
  const [teamId, setTeamId] = useState<any>("");
  const [teamOpen, setTeamOpen] = useState(false);
  const [salesTeamLoaded, setSalesTeamLoaded] = useState(false);
  const teamRef = useRef<HTMLDivElement>(null);
  const initialLoadDone = useRef(false);

  const safePreSaleStageData =
    preSaleStageData && preSaleStageData.length > 0
      ? preSaleStageData
      : ["Initial"];
  const safeSaleStageData =
    saleStageData && saleStageData.length > 0 ? saleStageData : ["Initial"];

  const teamMapping = teamStageCount.map(
    (d: { team_name: any }, index: any) => ({ name: d.team_name, index })
  );
  const series = teamStageCount.map(
    (team: { [x: string]: any; team_name: any }) => ({
      label: team.team_name,
      data: safePreSaleStageData
        .map((stage: string | number) => team[stage] ?? 0)
        .filter((v: undefined) => v !== undefined),
    })
  );
  const salesTeamMapping = salesTeamStageCount.map(
    (d: { team_name: any }, index: any) => ({ name: d.team_name, index })
  );
  const seriesSalesTeam = salesTeamStageCount.map(
    (team: { [x: string]: any; team_name: any }) => ({
      label: team.team_name,
      data: safeSaleStageData
        .map((stage: string | number) => team[stage] ?? 0)
        .filter((v: undefined) => v !== undefined),
    })
  );

  const location = useLocation();
  const activeOrganizationId = useSelector(selectActiveOrganizationId);
  const memberships = useSelector(selectMemberships);

  const activeOrganizationLabel = useMemo(() => {
    if (!activeOrganizationId || activeOrganizationId === "all" || activeOrganizationId === "*") {
      return "All organizations";
    }
    const fromMembership = (memberships || []).find(
      (m) => String(m.organizationId) === String(activeOrganizationId)
    );
    const membershipName =
      fromMembership?.organization?.name ||
      fromMembership?.organization?.brandName ||
      "";
    if (membershipName) return membershipName;
    try {
      const cachedId = sessionStorage.getItem("active_organization_id");
      const cachedLabel = sessionStorage.getItem("active_organization_label");
      if (
        cachedLabel &&
        cachedId &&
        String(cachedId) === String(activeOrganizationId)
      ) {
        return cachedLabel;
      }
    } catch (_) {}
    return "Selected organization";
  }, [activeOrganizationId, memberships]);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (teamRef.current && !teamRef.current.contains(e.target as Node)) {
        setTeamOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const mapTeamList = (teams: any[] = []) =>
    teams.flatMap((team: any) => {
      const entries: any[] = [];
      if (team.team_name) {
        entries.push({
          id: team._id,
          label: team.team_name,
          isParent: true,
        });
      }
      if (team.sub_teams && Array.isArray(team.sub_teams)) {
        team.sub_teams.forEach((subTeam: any) => {
          entries.push({
            id: subTeam._id,
            label: subTeam.team_name,
            isParent: false,
          });
        });
      }
      return entries;
    });

  const applyStageMeta = (stageData: any) => {
    const stages = stageData?.data || [];
    setPreSaleStageData(
      stages
        .filter((item: any) => item.isSale === 0 || item.isSale === -1)
        .flatMap(
          (item: any) =>
            item.sub_Stage_name?.map((sub: any) => sub.stage_Name) || []
        )
    );
    setSaleStageData(
      stages
        .filter((item: any) => item.isSale === 1 || item.isSale === -1)
        .flatMap(
          (item: any) =>
            item.sub_Stage_name?.map((sub: any) => sub.stage_Name) || []
        )
    );
  };

  const applyParentStageTotals = (stageCounts: any) => {
    setDashbordAllStage(stageCounts || {});
    const total = Object.values(stageCounts || {}).reduce(
      (sum: number, value: any) => sum + (Number(value) || 0),
      0
    );
    setDashboardDataAllLead({ total });
  };

  const fetchTeamScopedData = async (activeTeamId?: string) => {
    const teamKey = activeTeamId || "";
    const [sourceRes, parentStageRes, preSalesRes, salesRes] =
      await Promise.all([
        getDashboardSourceCount(teamKey),
        getDashboardParentStageCount(teamKey),
        getDashboardPreSalesStageCount(teamKey),
        getDashboardSalesStageCount(teamKey),
      ]);

    setDashboardSourceCount(sourceRes?.data || []);
    applyParentStageTotals(parentStageRes?.data);
    setFunnelPreSalesStages(preSalesRes?.data || []);
    setFunneelSalesSatges(salesRes?.data || {});
  };

  const loadInitialDashboard = async () => {
    setLoading(true);
    // KPI counts paint first. Team list, projects, and stage labels fill in after.
    fetchTeamScopedData("")
      .catch((error: any) => {
        openErrorNotification(
          isTruthy(error?.message) ? error.message : notifiers.GENERIC_ERROR
        );
      })
      .finally(() => {
        initialLoadDone.current = true;
        setLoading(false);
      });

    getTeamList()
      .then((teamRes) => setTeamList(mapTeamList(teamRes?.data)))
      .catch(() => {});
    getDataProject({ startDate: "", endDate: "" })
      .then((projectRes) => setDashboardDataProject(projectRes?.data?.[0] || {}))
      .catch(() => {});
    getStage()
      .then((stageMetaRes) => applyStageMeta(stageMetaRes))
      .catch(() => {});
    getDashboardTeamStageCount()
      .then((teamStageRes) => setTeamStageCount(teamStageRes?.data || []))
      .catch(() => {});
  };

  const reloadTeamScopedDashboard = async (activeTeamId?: string) => {
    try {
      setLoading(true);
      await fetchTeamScopedData(activeTeamId);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname === "/dashboard-admin") {
      initialLoadDone.current = false;
      setTeamId("");
      setSalesTeamLoaded(false);
      loadInitialDashboard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, activeOrganizationId]);

  useEffect(() => {
    if (!initialLoadDone.current) return;
    reloadTeamScopedDashboard(teamId?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId]);

  const handleChange = (newValue: number) => {
    setValue(newValue);
  };

  const handleTeamChange = async (newValue: number) => {
    setSelectedTeam(newValue);
    if (newValue === 0) {
      if (!teamStageCount?.length) {
        const teamstageCount = await getDashboardTeamStageCount();
        setTeamStageCount(teamstageCount.data);
      }
      return;
    }
    if (!salesTeamLoaded) {
      const salesTeamstageCount = await getDashboardSalesTeamStageCount();
      setSalesTeamStageCount(salesTeamstageCount.data);
      setSalesTeamLoaded(true);
    }
  };

  const pieChartData = (dashboardSourceCount || [])?.map(
    (item: any, index: any) => ({
      id: index,
      value: item.count,
      name: item.source,
    })
  );

  const handleStartSetup = () => {
    history.push({
      pathname: urls.accountSettingsViewPth,
      state: { fromPage: "Dashboad" },
    });
  };

  const dialogTitleContent = () => (
    <div className="flex flex-col items-center gap-5 px-5 py-2.5 text-center">
      <div>
        <h2 className="font-yh-bold text-xl text-yh-black">Complete Setup</h2>
        <p className="mt-1 text-xs text-yh-light-gray">
          Thank you fo signing up. Please setup your account to continue.
        </p>
      </div>
      <CustomButton
        label="Start Setup"
        onClick={handleStartSetup}
        buttonType="primaryBtn"
      />
    </div>
  );

  const tilesData = [
    {
      id: 1,
      text: "Total Leads",
      count: dashboardDataAllLead?.total || 0,
      image: DashboardIcon,
    },
    {
      id: 2,
      text: "Contact",
      count: dashboardDataStageAll?.Contact || 0,
      image: DashboardIcon,
    },
    {
      id: 3,
      text: "Lead",
      count: dashboardDataStageAll?.Lead || 0,
      image: userNew,
    },
    {
      id: 4,
      text: "Prospect",
      count: dashboardDataStageAll?.Prospect || 0,
      image: userNew1,
    },
    {
      id: 5,
      text: "Opportunity",
      count: dashboardDataStageAll?.Opportunity || 0,
      image: userNew2,
    },
    {
      id: 6,
      text: "Closure",
      count: dashboardDataStageAll?.Closure || 0,
      image: userNew2,
    },
    {
      id: 7,
      text: "Not Interested",
      count:
        dashboardDataStageAll?.["Not Interested"] ||
        dashboardDataStageAll?.["Not Intrested"] ||
        0,
      image: userNew,
    },
  ];

  const lineChartDataPre = safePreSaleStageData.map(
    (stage: string, stageIdx: number) => {
      const row: any = { stage };
      series.forEach((s: any, i: number) => {
        row[teamMapping[i]?.name || `Series ${i + 1}`] = s.data[stageIdx] ?? 0;
      });
      return row;
    }
  );

  const lineChartDataSales = safeSaleStageData.map(
    (stage: string, stageIdx: number) => {
      const row: any = { stage };
      seriesSalesTeam.forEach((s: any, i: number) => {
        row[salesTeamMapping[i]?.name || `Series ${i + 1}`] =
          s.data[stageIdx] ?? 0;
      });
      return row;
    }
  );

  const barData = [
    {
      name: "Commercial",
      count: dashboardDataProject?.projects_commercial || 0,
    },
    {
      name: "Residential",
      count: dashboardDataProject?.projects_residencial || 0,
    },
  ];

  const selectableTeams = (teamList || []).filter((t: any) => !t.isParent);

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  const userName = store.getState()?.auth?.userName || "there";

  const pieTotal = (pieChartData || []).reduce(
    (sum: number, item: any) => sum + (Number(item.value) || 0),
    0
  );

  return (
    <>
      <div className="h-[calc(100vh-56px)] overflow-auto bg-white p-4 sm:p-5 lg:p-6 [scrollbar-width:thin]">
        {/* Header */}
        <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-[#111827]">
              {greeting}, {userName}! 👋
            </h2>
            <p className="mt-1 text-sm text-[#6B7280]">
              Here&apos;s what&apos;s happening with{" "}
              <span className="font-semibold text-[#841C39]">
                {activeOrganizationLabel}
              </span>{" "}
              today.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2.5">
            <div className="relative w-[320px]" ref={teamRef}>
              <FilterChip
                onClick={() => setTeamOpen((o) => !o)}
                active={!!teamId?.label}
                className="!w-full !min-w-0 !justify-between"
              >
                <span className="min-w-0 flex-1 truncate text-left">
                  {teamId?.label || "All Teams"}
                </span>
                <ChevronSvg />
              </FilterChip>
              {teamOpen && (
                <div className="absolute left-0 right-0 z-30 mt-1 max-h-[420px] w-full overflow-auto rounded-xl border border-[#E5E7EB] bg-white shadow-[0_8px_30px_rgba(15,23,42,0.08)] [scrollbar-width:thin]">
                  {(teamList || []).map((option: any) => (
                    <button
                      key={`${option.id}-${option.label}`}
                      type="button"
                      disabled={option.isParent}
                      onClick={() => {
                        if (!option.isParent) {
                          setTeamId(option);
                          setTeamOpen(false);
                        }
                      }}
                      className={`block w-full truncate px-4 py-2.5 text-left text-sm ${
                        option.isParent
                          ? "cursor-default font-bold text-[#841C39]"
                          : "pl-6 font-normal text-[#111827] hover:bg-[#F9F0F4]"
                      }`}
                    >
                      {option.label}
                    </button>
                  ))}
                  {!selectableTeams.length && (
                    <p className="px-4 py-2 text-sm text-[#9CA3AF]">No teams</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* KPI tiles */}
        <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-7">
          {tilesData.map((item) => (
            <CustomTile
              key={item.id}
              releaseText={item.text}
              number={item.count}
              imageUrl={item.image}
              loading={loading}
            />
          ))}
        </div>

        <DashboardIvrPanel />

        {/* Charts row */}
        <div className="mb-5 grid grid-cols-1 gap-4 xl:grid-cols-12">
          <Card className="xl:col-span-5">
            <PanelHeader title="Opportunity Pipeline" />
            <UnderlineTabs
              tabs={["Pre-Sales Pipeline", "Sales Pipeline"]}
              value={value}
              onChange={handleChange}
            />
            <div className="min-h-[300px] px-4 py-4 sm:px-5">
              {loading ? (
                <SkeletonBlock height={260} />
              ) : opportunityViewMode === "chart" ? (
                value === 0 ? (
                  <FunnelChart data={funnelPreSalesStages} />
                ) : (
                  <FunnelChart data={funnelSalesSatges} />
                )
              ) : null}
            </div>
          </Card>

          <Card className="xl:col-span-4">
            <div className="flex items-center justify-between border-b border-[#EEF0F5] px-5 py-3.5">
              <h3 className="text-[15px] font-bold text-[#111827]">Lead Source</h3>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-[#6B7280]">
                This Month
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </span>
            </div>
            <div className="flex min-h-[340px] flex-col p-5">
              {loading ? (
                <SkeletonBlock height={280} />
              ) : leadSourceViewMode === "chart" ? (
                <>
                  <div className="flex flex-1 items-center gap-6">
                    <div className="relative h-[250px] w-[250px] shrink-0 sm:h-[270px] sm:w-[270px]">
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={pieChartData}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            innerRadius={54}
                            outerRadius={122}
                            paddingAngle={2}
                            stroke="#fff"
                            strokeWidth={3}
                            labelLine={false}
                            label={({
                              cx,
                              cy,
                              midAngle,
                              innerRadius,
                              outerRadius,
                              percent,
                            }: any) => {
                              if (!percent || percent < 0.04) return null;
                              const RADIAN = Math.PI / 180;
                              const radius =
                                innerRadius + (outerRadius - innerRadius) * 0.5;
                              const x =
                                cx + radius * Math.cos(-midAngle * RADIAN);
                              const y =
                                cy + radius * Math.sin(-midAngle * RADIAN);
                              return (
                                <text
                                  x={x}
                                  y={y}
                                  fill="#fff"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  fontSize="12"
                                  fontWeight="700"
                                >
                                  {`${Math.round(percent * 100)}%`}
                                </text>
                              );
                            }}
                          >
                            {pieChartData.map((_: any, index: number) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={CHART_COLORS[index % CHART_COLORS.length]}
                              />
                            ))}
                          </Pie>
                          <Tooltip
                            formatter={(value: any, name: any) => [
                              Number(value).toLocaleString(),
                              name,
                            ]}
                            contentStyle={{
                              borderRadius: 12,
                              border: "1px solid #EEF0F5",
                              boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
                            }}
                          />
                        </PieChart>
                      </ResponsiveContainer>
                      <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
                        <p className="text-[24px] font-bold leading-none tracking-tight text-[#111827]">
                          {pieTotal.toLocaleString()}
                        </p>
                        <p className="mt-1.5 text-xs font-medium text-[#9CA3AF]">
                          Total
                        </p>
                      </div>
                    </div>

                    <ul className="m-0 ml-auto flex w-[160px] list-none flex-col items-stretch justify-center gap-2.5 p-0 sm:w-[180px]">
                      {(pieChartData || []).map((item: any, index: number) => (
                        <li
                          key={`${item.name}-${index}`}
                          className="flex items-center gap-2.5"
                        >
                          <span
                            className="h-2.5 w-2.5 shrink-0 rounded-[3px]"
                            style={{
                              backgroundColor:
                                CHART_COLORS[index % CHART_COLORS.length],
                            }}
                          />
                          <span className="truncate text-sm font-medium text-[#374151]">
                            {item.name || "Unknown"}
                          </span>
                        </li>
                      ))}
                      {!pieChartData?.length && (
                        <li className="text-sm text-[#9CA3AF]">No sources</li>
                      )}
                    </ul>
                  </div>

                  <div className="mt-auto flex justify-end border-t border-[#EEF0F5] pt-4">
                    <button
                      type="button"
                      className="text-sm font-semibold text-[#841C39] hover:underline"
                      onClick={() => history.push(urls.ALLLEADFORMLIST)}
                    >
                      View all sources →
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </Card>

          <Card className="xl:col-span-3">
            <PanelHeader title="Project Leads" />
            <div className="p-4">
              {loading ? (
                <SkeletonBlock height={280} />
              ) : leadProjectViewMode === "chart" ? (
                <ResponsiveContainer width="100%" height={280}>
                  <BarChart data={barData} barSize={48}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#EEF0F5" vertical={false} />
                    <XAxis
                      dataKey="name"
                      tick={{ fontSize: 12, fill: "#6B7280" }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <YAxis
                      tick={{ fontSize: 12, fill: "#6B7280" }}
                      axisLine={false}
                      tickLine={false}
                    />
                    <Tooltip
                      contentStyle={{
                        borderRadius: 12,
                        border: "1px solid #EEF0F5",
                        boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
                      }}
                    />
                    <Bar dataKey="count" radius={[10, 10, 0, 0]}>
                      {barData.map((_: any, index: number) => (
                        <Cell
                          key={`bar-${index}`}
                          fill={index === 0 ? "#841C39" : "#000000"}
                        />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              ) : null}
            </div>
          </Card>
        </div>

        {/* Team performance */}
        <Card>
          <PanelHeader title="Team Lead Performance" />
          <div className="flex flex-col gap-2 border-b border-[#EEF0F5] px-4 sm:flex-row sm:items-center sm:justify-between">
            <UnderlineTabs
              tabs={["Pre-Sales Team", "Sales Team"]}
              value={selectedTeam}
              onChange={handleTeamChange}
            />
          </div>
          <div className="p-4 sm:p-5">
            {loading ? (
              <SkeletonBlock height={280} />
            ) : (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  data={
                    selectedTeam === 0 ? lineChartDataPre : lineChartDataSales
                  }
                  margin={{ left: 8, bottom: 24, top: 16, right: 16 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#EEF0F5" />
                  <XAxis
                    dataKey="stage"
                    tick={{ fontSize: 11, fill: "#6B7280", fontWeight: 500 }}
                    angle={-25}
                    textAnchor="end"
                    height={55}
                    axisLine={false}
                    tickLine={false}
                  />
                  <YAxis
                    tick={{ fontSize: 12, fill: "#6B7280" }}
                    axisLine={false}
                    tickLine={false}
                  />
                  <Tooltip
                    contentStyle={{
                      borderRadius: 12,
                      border: "1px solid #EEF0F5",
                      boxShadow: "0 8px 24px rgba(15,23,42,0.08)",
                    }}
                  />
                  <Legend
                    wrapperStyle={{ fontSize: 12, fontWeight: 600 }}
                    iconType="circle"
                  />
                  {(selectedTeam === 0 ? teamMapping : salesTeamMapping).map(
                    (team: any, i: number) => (
                      <Line
                        key={team.name || i}
                        type="monotone"
                        dataKey={team.name || `Series ${i + 1}`}
                        stroke={CHART_COLORS[i % CHART_COLORS.length]}
                        strokeWidth={3}
                        dot={{ r: 3, strokeWidth: 0 }}
                        activeDot={{ r: 5 }}
                      />
                    )
                  )}
                </LineChart>
              </ResponsiveContainer>
            )}
          </div>
        </Card>
      </div>

      <CustomDialog
        isDialogOpen={false}
        dialogTitleContent={dialogTitleContent()}
        handleDialogClose={props.handleClose}
      />
    </>
  );
};

export default Dashboard;
